import axios from 'axios';

// 创建axios实例
const api = axios.create({
  baseURL: '/api',
  timeout: 60000, // 增加到60秒
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 如果是FormData，让axios自动设置Content-Type
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    // 添加认证token
    const token = localStorage.getItem('token');
    // 用户端token
    if (token && config.url.includes('/user/')) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 门店端token
    const storeToken = localStorage.getItem('store_token');
    if (storeToken && config.url.includes('/store/')) {
      config.headers.Authorization = `Bearer ${storeToken}`;
    }
    // 管理端token
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken && config.url.includes('/admin/')) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.error('API请求错误:', error);
    if (error.response?.status === 401) {
      // 清除token并跳转到登录页
      localStorage.removeItem('token');
      // 这里可以添加路由跳转逻辑
    }
    return Promise.reject(error);
  }
);

// 导出HTTP方法
export const get = (url, params = {}) => {
  return api.get(url, { params });
};

export const post = (url, data = {}) => {
  return api.post(url, data);
};

export const put = (url, data = {}) => {
  return api.put(url, data);
};

export const del = (url) => {
  return api.delete(url);
};

export default api;